<div
  class="editor-panel-header component-header aligner tw-flex tw-items-center tw-gap-3 tw-mt-10"
  [class.canva-connect-header]="headerMode === 'canva'"
  [class.back-title-header]="headerMode === 'back-title'"
  [class.storage-selector-header]="
    componentsService.getCurrentPage() &&
    componentsService.getCurrentPage().type === 'rise-storage-selector' &&
    storageManagerService.fileType === 'image'
  "
>
  @switch (headerMode) {
    @case ('back-title') {
      <button
        type="button"
        id="back-button"
        class="tw-flex tw-h-8 tw-w-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-black"
        aria-label="Go back to previous view"
        (click)="componentsService.onBackButton()"
      >
        <mat-icon
          svgIcon="arrow-left"
          aria-hidden="true"
          class="tw-h-5 tw-w-5"
        ></mat-icon>
      </button>
      <h2
        class="u_text-ellipsis mr-auto tw-m-0 tw-text-[16px] tw-font-bold tw-leading-6"
        role="heading"
        aria-level="2"
      >
        {{ getComponentLabel(componentsService.selected) }}
      </h2>
    }
    @case ('canva') {
      <button
        type="button"
        id="back-button"
        class="tw-flex tw-h-8 tw-w-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-black"
        aria-label="Go back to previous view"
        (click)="componentsService.onBackButton()"
      >
        <mat-icon
          svgIcon="arrow-left"
          aria-hidden="true"
          class="tw-h-5 tw-w-5"
        ></mat-icon>
      </button>
      <h2
        class="u_text-ellipsis tw-m-0 tw-text-[16px] tw-font-bold tw-leading-6"
        role="heading"
        aria-level="2"
      >
        Select a Canva design
      </h2>
      <rv-badge
        class="badge-canva-powered"
        appearance="solid"
        color="blue"
        labelSize="small"
        text="Powered by Canva"
      />
    }
    @default {
      <button
        type="button"
        id="back-button"
        class="tw-flex tw-h-8 tw-w-8 tw-min-w-8 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-black"
        aria-label="Go back to previous view"
        (click)="componentsService.onBackButton()"
      >
        <mat-icon
          svgIcon="arrow-left"
          aria-hidden="true"
          class="tw-h-5 tw-w-5"
        ></mat-icon>
      </button>
      <h2
        class="u_text-ellipsis mr-auto tw-m-0 tw-text-[16px] tw-font-bold tw-leading-6"
        role="heading"
        aria-level="2"
      >
        {{ getComponentLabel(componentsService.selected) }}
      </h2>
    }
  }
  @if (
    componentsService.getCurrentPage() &&
    componentsService.getCurrentPage().type === 'rise-storage-selector' &&
    storageManagerService.fileType === 'image'
  ) {
    <list-grid-toggle
      [(isListView)]="storageManagerService.isListView"
    ></list-grid-toggle>
  }
</div>

<!-- Load instagram svg so that svg defs with ID(s) can be used by other instagram svg instances below. -->
<mat-icon
  aria-hidden="true"
  svgIcon="integration-instagram"
  class="instagram-svg-defs"
></mat-icon>

<div class="component-container">
  <component-media-selector></component-media-selector>
  <component-image-ai></component-image-ai>
  <template-component-layout-ai></template-component-layout-ai>
  <component-custom-font-selector></component-custom-font-selector>
  <component-storage-selector></component-storage-selector>
  <component-playlist-item-selector></component-playlist-item-selector>
  <component-canva-connect></component-canva-connect>
  <template-component-branding></template-component-branding>
  <template-branding-colors></template-branding-colors>
  <template-component-schedules></template-component-schedules>
  <template-component-financial></template-component-financial>
  <template-component-folder></template-component-folder>
  <template-component-image></template-component-image>
  <template-component-slides></template-component-slides>
  <template-component-youtube></template-component-youtube>
  <template-component-text></template-component-text>
  <template-component-icon></template-component-icon>
  <template-component-video></template-component-video>
  <template-component-rss></template-component-rss>
  <template-component-counter></template-component-counter>
  <template-component-time-date></template-component-time-date>
  <template-component-colors></template-component-colors>
  <template-component-twitter></template-component-twitter>
  <template-component-weather></template-component-weather>
  <component-presentation-selector></component-presentation-selector>
  <template-component-playlist></template-component-playlist>
  <template-component-html></template-component-html>
  <template-component-stock-library></template-component-stock-library>
  <template-component-calendar></template-component-calendar>
  <template-component-data-table></template-component-data-table>
  <template-component-web-page></template-component-web-page>
  <template-component-domo></template-component-domo>
  <template-component-powerbi></template-component-powerbi>
  <template-component-document></template-component-document>
  <template-share-settings></template-share-settings>
  <template-component-social-media-posts></template-component-social-media-posts>
  <template-component-social-media-followers></template-component-social-media-followers>
  <template-component-video-streaming></template-component-video-streaming>
  <template-component-screen-sharing></template-component-screen-sharing>
  <template-component-layout-weather></template-component-layout-weather>
  <template-component-layout-time></template-component-layout-time>
  <template-component-layout-date></template-component-layout-date>
  <template-component-layout-ems></template-component-layout-ems>
  <template-component-layout-calendar></template-component-layout-calendar>
  <template-component-layout-rss></template-component-layout-rss>
  <template-component-layout-counter></template-component-layout-counter>
  <template-component-layout-table></template-component-layout-table>
</div>
